require('./RACustomAccordion.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

class RACustomAccordion extends React.Component {
    buildRightIcon() {
        return (
            <i
                className="ra-accordion-wizard-step__icon-edit icon-s-editar"
                onClick={this.props.onRightIconClick}
            />
        );
    }

    render() {
        const {
            children,
            customClassName,
            customTitleClassName,
            isExpanded,
            leftIconClass,
            rightIconClass,
            title,
            optionalTitle,
            optionalTitleClassName,
            activateOnClickOfAccordion,
            onClickOfAccordion,
        } = this.props;
        const accordionClass = classnames('ra-custom-accordion', {
            [customClassName]: customClassName,
        });
        const bodyClass = classnames('ra-custom-accordion__body', 'clearfix', {
            'ra-custom-accordion__body--expanded': isExpanded,
        });
        const headerTitleClass = customTitleClassName
            ? customTitleClassName
            : classnames('ra-custom-accordion__header-title', {
                  'ra-custom-accordion__header-title--expanded': isExpanded,
              });
        const rightIcon = rightIconClass ? this.buildRightIcon() : null;
        const content = isExpanded ? children : null;
        const optionalTitleElement = optionalTitleClassName ? (
            <span className={optionalTitleClassName}>{optionalTitle}</span>
        ) : (
            <span>{optionalTitle}</span>
        );

        return (
            <div
                className={accordionClass}
                onClick={activateOnClickOfAccordion ? onClickOfAccordion : null}
            >
                <div className="ra-custom-accordion__header">
                    <i className={leftIconClass}></i>
                    <div className="ra-custom-accordion__header-content no-print-out">
                        <div className={headerTitleClass}>
                            {title} {optionalTitleElement}
                        </div>
                        {rightIcon}
                    </div>
                </div>
                <div className={bodyClass}>{content}</div>
            </div>
        );
    }
}

RACustomAccordion.propTypes = {
    activateOnClickOfAccordion: PropTypes.bool.isRequired,
    children: PropTypes.any.isRequired,
    customClassName: PropTypes.string,
    customTitleClassName: PropTypes.string,
    isExpanded: PropTypes.bool.isRequired,
    leftIconClass: PropTypes.string.isRequired,
    onRightIconClick: PropTypes.func,
    rightIconClass: PropTypes.string,
    title: PropTypes.string.isRequired,
    optionalTitle: PropTypes.string,
    optionalTitleClassName: PropTypes.string,
    onClickOfAccordion: PropTypes.func,
};

RACustomAccordion.defaultProps = {
    optionalTitle: null,
    optionalTitleClassName: null,
};

module.exports = RACustomAccordion;
